var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgS4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_793_223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.5312 11.25H4.6875V10.7812C4.6875 10.5234 4.47656 10.3125 4.21875 10.3125H3.28125C3.02344 10.3125 2.8125 10.5234 2.8125 10.7812V11.25H0.46875C0.210938 11.25 0 11.4609 0 11.7188V12.6562C0 12.9141 0.210938 13.125 0.46875 13.125H2.8125V13.5938C2.8125 13.8516 3.02344 14.0625 3.28125 14.0625H4.21875C4.47656 14.0625 4.6875 13.8516 4.6875 13.5938V13.125H14.5312C14.7891 13.125 15 12.9141 15 12.6562V11.7188C15 11.4609 14.7891 11.25 14.5312 11.25ZM14.5312 6.5625H12.1875V6.09375C12.1875 5.83594 11.9766 5.625 11.7188 5.625H10.7812C10.5234 5.625 10.3125 5.83594 10.3125 6.09375V6.5625H0.46875C0.210938 6.5625 0 6.77344 0 7.03125V7.96875C0 8.22656 0.210938 8.4375 0.46875 8.4375H10.3125V8.90625C10.3125 9.16406 10.5234 9.375 10.7812 9.375H11.7188C11.9766 9.375 12.1875 9.16406 12.1875 8.90625V8.4375H14.5312C14.7891 8.4375 15 8.22656 15 7.96875V7.03125C15 6.77344 14.7891 6.5625 14.5312 6.5625ZM14.5312 1.875H8.4375V1.40625C8.4375 1.14844 8.22656 0.9375 7.96875 0.9375H7.03125C6.77344 0.9375 6.5625 1.14844 6.5625 1.40625V1.875H0.46875C0.210938 1.875 0 2.08594 0 2.34375V3.28125C0 3.53906 0.210938 3.75 0.46875 3.75H6.5625V4.21875C6.5625 4.47656 6.77344 4.6875 7.03125 4.6875H7.96875C8.22656 4.6875 8.4375 4.47656 8.4375 4.21875V3.75H14.5312C14.7891 3.75 15 3.53906 15 3.28125V2.34375C15 2.08594 14.7891 1.875 14.5312 1.875Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_793_223"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgS4);
export default __webpack_public_path__ + "static/media/s4.813fa8b790b5e4cf62c83beb137724bb.svg";
export { ForwardRef as ReactComponent };